<template>
  <div class="kp-modular-row clearfix">
    <label class="kp-modular-label">{{ label }}</label>
    <div class="box-color">
      <input :id="id" type="text" :value="this.value" style="display: inline-block;" @change="onChange($event.target.value)">
      <span class="view-color"></span>
    </div>
  </div>
</template>

<script>
import 'spectrum-colorpicker';
import $ from 'jquery';
import tinycolor from 'tinycolor2';

export default {
  props: [
    'id',
    'label',
    'change',
    'move',
    'value',
  ],
  data() {
    return {
      config: {
        preferredFormat: 'rgb',
        color: this.value,
        showPalette: true,
        showAlpha: true,
        togglePaletteMoreText: '+',
        togglePaletteLessText: '',
        containerClassName: 'kp-colorpicker',
        replacerClassName: 'view-color',
        palette: [
          'rgba(230,49,91,1)',
          'rgba(121,49,131,1)',
          'rgba(0,157,231,1)',
          'rgba(0,181,156,1)',
          'rgba(255,206,0,1)',
          'rgba(255,74,33,1)',
          'rgba(214,213,214,1)',
          'rgba(255,255,255,1)',
          'rgba(0,0,0,1)',
        ],
        localStorageKey: 'klick.edit.colors',
        maxSelectionSize: 9,
        chooseText: '',
        cancelText: '',
      },
    };
  },
  updated() {
    this.config.color = this.value;
    this.getInput().spectrum('set', this.value);
  },
  mounted() {
    this.bindEvents();
    this.setup();
    this.getInput().on('focus', () => this.open());
  },
  methods: {
    open() {
      this.setup();
      setTimeout(() => this.getInput().spectrum('show'), 75);
    },
    onChange(color) {
      this.change(this.getTinyColor(color));
    },
    onMove(color) {
      this.move(this.getTinyColor(color));
    },
    bindEvents() {
      this.config.change = this.onChange;
      this.config.move = this.onMove;
    },
    setup() {
      this.getInput().spectrum(this.config).show();
    },
    getTinyColor(color) {
      if (!color.toRgbString) {
        color = tinycolor(color);
      }

      return color.toRgbString();
    },
    getInput() {
      return $(document.getElementById(this.id));
    },
  },
};
</script>



/** WEBPACK FOOTER **
 ** ColorPicker.vue?0fbb1d93
 **/